import React, { FC } from "react";
import { WhatsappIcon, WhatsappShareButton } from "react-share";
import { BASE_URL } from "../../api/config";
import ShareVideo from "../../popups/ShareVideo/ShareVideo";
import { clss } from "../../utils/helpers/styleHelpers";
import Button, { ButtonModeE } from "../Button/Button";
import Icon from "../Icon/Icon";
import { H1, Span } from "../Text/Text";
import usePopup from "./../../utils/hooks/usePopup";

import styles from "./shareOptions.module.scss";

type ShareOptionsPropTypes = {
  withShareIcon?: boolean;
  Id?: number;
  onClose?: () => void;
  type: "video" | "delivery" | "campaign";
  viewProjectPage?: boolean;
  addClassName?: string;
  videoUrl?: string;
};

const ShareOptions: FC<ShareOptionsPropTypes> = (props) => {
  const {
    withShareIcon,
    Id,
    onClose = () => {},
    type,
    viewProjectPage,
    addClassName,
    videoUrl,
  } = props;
  const { createPopup, removePopup } = usePopup();

  const handleShareViaMail = () => {
    createPopup({
      header: <H1>Share the {type}</H1>,
      body: <ShareVideo Id={Id} type={type} />,
      footer: (
        <div className={styles.footerButtons}>
          <Button mode={ButtonModeE.OUTLINED} onClick={removePopup}>
            Cancel
          </Button>
          <Button form="share-video" useGlobalLoading>
            {" "}
            Send
          </Button>
        </div>
      ),
      className: styles.popupWrapper,
    });
  };

  return (
    <>
      {viewProjectPage && <div className={styles.overlay} onClick={onClose} />}
      <div
        className={clss([
          viewProjectPage ? styles.wrapperViewProjectPage : styles.wrapper,
          addClassName,
        ])}
      >
        {withShareIcon && <Icon name="share" />}
        <Span>Share: </Span>
        <Icon name="mailColor" onClick={handleShareViaMail} />
        <div className={styles.whatsappIcon}>
          {/*@ts-ignore*/}
          <WhatsappShareButton
            url={type === "video" ? videoUrl : window.location.href}
            title="You got JUMBOMedia share!"
          >
            <Icon name="whatsappColor" />
          </WhatsappShareButton>
        </div>
      </div>
    </>
  );
};

export default ShareOptions;
